import React from "react";

const ModalButton = ({onClick, text, iconClass, additionalClass, disabled}) =>
{
    const clsName = additionalClass === undefined ? '' : additionalClass ;
    const disabledState = disabled === undefined ? false : disabled ;

    return (
        <button onClick={onClick} disabled={disabledState} className={"btn btn-icon btn-icon-right btn-small " + clsName}>{text}<i className={iconClass}/></button>
    )
}

export default ModalButton ;
